import * as React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const contactMethods = [{
  id: 1,
  type: "Telefon",
  value: "+420 733 465 127",
  icon: Phone,
  actionLink: "tel:+420733465127",
  actionText: "Rezervovat"
}, {
  id: 2,
  type: "WhatsApp",
  value: "Napište nám zprávu",
  icon: Mail,
  actionLink: "https://wa.me/420733465127",
  actionText: "Napsat zprávu"
}, {
  id: 3,
  type: "Otevírací doba",
  value: "Po - Pá: 09:00 - 20:00\nSobota: 10:00 - 17:00",
  icon: MapPin,
  actionLink: "/ContactPage",
  actionText: "Kde nás najdete"
}];
export default function ReachOutToMunirAhmed() {
  return <section data-section-id="226028" id="telefonické-rezervace" className="text-foreground py-24 px-4 md:px-8 lg:py-32 overflow-hidden relative bg-background">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-primary/10 blur-[120px] rounded-lg pointer-events-none" aria-hidden="true" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="font-default text-primary text-4xl md:text-5xl lg:text-6xl tracking-wider mb-6">
            Telefonické rezervace
          </h2>
          <p className="font-default text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Vstupte do světa smyslnosti a relaxace. Pro zajištění vašeho termínu nás prosím kontaktujte telefonicky.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 justify-items-center">
          {contactMethods.map((method, i) => {
          const Icon = method.icon;
          return <Card key={method.id} data-index={i} className="text-card-foreground gap-6 rounded-xl py-6 flex flex-col text-center bg-card/40 border-border/20 backdrop-blur-md transition-all duration-500 group !items-center hover:-translate-y-2 hover:shadow-2xl hover:shadow-primary/20 hover:border-primary/40 justify-center">
                <CardHeader className="@container/card-header @container/card-header px-6 @container/card-header @container/card-header @container/card-header @container/card-header @container/card-header @container/card-header @container/card-header @container/card-header @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 ![padding:32px_24px_16px_24px] ![margin:0px_0px_0px_-80px]">
                  <div className="rounded-lg bg-background border border-border/30 group-hover:bg-primary/10 group-hover:border-primary/50 transition-colors duration-300 !w-[60px] !p-4 ![margin:0px_0px_16px_5px]">
                    <Icon className="w-6 h-6 text-primary" strokeWidth={1} />
                  </div>
                  <CardTitle className="font-default text-xl font-semibold tracking-widest uppercase !text-center ![padding:-0px_0px_-0px_0px] ![margin:0px_-50px_0px_-28px]">
                    {method.type}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow px-6 pb-8">
                  <p className="text-muted-foreground font-default text-base leading-relaxed !text-center">
                    {method.value}
                  </p>
                </CardContent>
                <CardFooter className="pb-8 pt-0 justify-center">
                  {method.actionText !== "Kde nás najdete" && <Button variant="secondary" size="lg" className="w-full sm:w-auto min-w-[160px] font-default tracking-widest uppercase border border-primary/30 hover:bg-primary hover:text-primary-foreground transition-all" asChild>
                      <Link to={method.actionLink} newTab={method.type === "WhatsApp"}>
                        {method.actionText}
                      </Link>
                    </Button>}
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}